import { intersect, partial, string, struct } from 'io-ts/Decoder';

import { Id as Level } from '../../../../ai/floor-level/Id';
import { Area } from '../../../../ui/geometry/Area';

export const Request = intersect(
	struct({
		name: string,
		level: Level,
	})
)(
	partial({
		area: Area,
	})
);
